/**
 * @generated SignedSource<<cbf051f19d0b552ff7e99e1e3cdefd41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsBioModalLazy_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModal_seller">;
  readonly " $fragmentType": "PdpSharedDealerDetailsBioModalLazy_seller";
};
export type PdpSharedDealerDetailsBioModalLazy_seller$key = {
  readonly " $data"?: PdpSharedDealerDetailsBioModalLazy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isExtended"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsBioModalLazy_seller",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isExtended",
          "variableName": "isExtended"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModal_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "94a0c90ddea787232f7245e45587decc";

export default node;
